import React from 'react';
import {Redirect} from "react-router-dom";
import {routesBase} from "v4/data/appRoutes";
import OAuthAuthorizePage from "v4/pages/front/OAuth/components/OAuthAuthorizePage/OAuthAuthorizePage";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";

export default function OAuthPage() {
    const {currentRoute} = useNavigation();

    const isAuthorizePage = currentRoute?.routeType === 'AUTHORIZE';

    if (isAuthorizePage) return <OAuthAuthorizePage/>

    return <Redirect to={routesBase.baseLogin}/>;
}
